// extracted by mini-css-extract-plugin
module.exports = {"title":"O-nDg9aX8cyZ9gxIXK+23A==","list":"yIpAyJMSE7iWIs-8dVHD4A==","item":"_14foVVQk6xevOwrNw2pI4A==","text":"Eprqq2QJLEZFs9rSSrXrrw=="};